<template>
  <div>
    <main-layout>
      <div class="content-wrap ledger-settings" v-loading="loading">
        <el-form
          :inline="true"
          size="small"
          label-width="100px"
          label-position="right"
          ref="ledgerSetSearchForm"
          :model="form"
        >
          <el-form-item label="部门/门店" prop="departmentId">
            <treeselect
              class="tree-select form-select"
              :default-expand-level="1"
              noOptionsText="暂无选项"
              noResultsText="暂无选项"
              v-model="form.departmentId"
              placeholder="请输入"
              :normalizer="normalizer"
              :options="departList"
            />
          </el-form-item>
          <el-form-item label="分账收款方" prop="payeeName">
            <el-input
              v-model="form.payeeName"
              placeholder="请输入"
              clearable
              class="w224"
            ></el-input>
          </el-form-item>
          <el-form-item label="分账状态" prop="status">
            <el-select v-model="form.status" class="w224">
              <el-option
                v-for="(item, index) in statusList"
                :key="index"
                :label="item.label"
                :value="item.val"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="ledger-search-operation-item">
            <el-button @click="search" type="primary" size="small">搜索</el-button>
            <el-button @click="resetSearchForm" size="small">重置</el-button>
          </el-form-item>
        </el-form>
        <div class="ledger-set-content">
          <el-button
            type="primary"
            size="small"
            @click="showAddDetail"
            class="show-add-ledger-button"
            >添加</el-button
          >
          <el-table :data="tableData">
            <el-table-column label="部门/门店" prop="departmentName" min-width="15%"> </el-table-column>
            <el-table-column label="最大分账比例" prop="subAccountRatioMax" min-width="12%">
              <template slot-scope="scope">
                <p class="column-set-maxProportion-text">{{ scope.row.subAccountRatioMax }}%</p>
              </template>
            </el-table-column>
            <el-table-column label="分账收款方" prop="payeeName" min-width="21%"> </el-table-column>
            <el-table-column label="分账比例" prop="subAccountRatio" min-width="12%">
              <template slot-scope="scope">
                <p class="column-set-proportion-text">{{ scope.row.subAccountRatio }}%</p>
              </template>
            </el-table-column>
            <el-table-column label="备注" prop="remark" min-width="16%"> </el-table-column>
            <el-table-column label="状态" prop="status" min-width="12%">
              <template slot-scope="scope">
                <p>
                  <i
                    class="iconfont icon-yuandian"
                    :style="{
                      color: scope.row.status ? '#5CD700' : '#FF003C',
                    }"
                  ></i>
                  {{ scope.row.status ? '启用中' : '停用中' }}
                </p>
              </template>
            </el-table-column>
            <el-table-column label="操作" min-width="12%">
              <template slot-scope="scope">
                <el-button type="text" @click="showEditDetail(scope.row)">编辑</el-button>
                <template v-if="scope.row.status">
                  <el-popover placement="top-end" width="250" v-model="scope.row.popVisible">
                    <div class="ledger-settings-popconfirm-title-wrap">
                      <i class="el-popconfirm__icon el-icon-info ledger-info-icon"></i>
                      <span>禁用后该部门/门店产生的新订单将不会继续分账给该收款方，确定禁用？</span>
                    </div>
                    <div style="text-align: right; margin: 20px 0 0 0">
                      <el-button size="mini" @click="handlePopoverClose(scope.row)">取消</el-button>
                      <el-button type="primary" size="mini" @click="changeStatus(scope.row)"
                        >确定</el-button
                      >
                    </div>
                    <el-button class="ledger-forbidden-text" type="text" slot="reference"
                      >禁用</el-button
                    >
                  </el-popover>
                </template>
                <template v-else
                  ><el-button type="text" @click="changeStatus(scope.row)">
                    启用</el-button
                  ></template
                >
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页 -->
          <Paging
            layout="prev, pager, next, total, sizes, jumper"
            v-if="total > 0"
            :currentPage="pageObj"
            :total="total"
            :handleCurrentChange="handleCurrentChange"
            :handleSizeChange="handleSizeChange"
            :pageSizes="[10, 50, 100]"
          ></Paging>
          <EditFormModal
            :addVisible="addVisible"
            :editVisible="editVisible"
            :editFormData="editFormData"
            :departList="departList"
            :pageObj="pageObj"
            @getTableData="getTableData"
            @handleClose="handleModalClose"
          />
        </div>
      </div>
    </main-layout>
  </div>
</template>
<script>
import MainLayout from '@/views/layout/mainlayout';
import Treeselect from '@riophae/vue-treeselect';
import Paging from '../../components/public/paging';
import EditFormModal from './editFormModal';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export default {
  name: 'LedgerSettings',
  components: {
    MainLayout,
    Treeselect,
    Paging,
    EditFormModal,
  },
  data() {
    return {
      aadAuth: true, // 添加分账部门门店权限
      editAuth: true, // 编辑分账部门门店权限
      setStatusAuth: true, // 禁用启用分账设置权限
      total: 8,
      pageObj: {
        pageSize: 10,
        currentPage: 1,
      },
      loading: false, // table加载
      tableData: [],
      departList: [], // 部门list
      date: '',
      form: {
        departmentId: null,
        payeeName: '',
        status: '',
      },
      statusList: [
        {
          label: '全部',
          val: null,
        },
        {
          label: '停用中',
          val: 0,
        },
        {
          label: '启用中',
          val: 1,
        },
      ],
      addVisible: false,
      editVisible: false,
      editFormData: {},
    };
  },
  created() {
    // 获取部门/门店信息
    this.api.post('load/getDeptTree.do', {}).then((res) => {
      if (res.code == '200') {
        this.departList = res.data;
      } else {
        this.$message.error(res.message);
      }
    });
    this.getTableData();
    // 权限判断
    const registerType = sessionStorage.getItem('registerType');
    if (registerType === '0') {
      const addSubAccountConfigAuth = JSON.parse(sessionStorage.getItem('addSubAccountConfig'));
      const editSubAccountConfigAuth = JSON.parse(sessionStorage.getItem('editSubAccountConfig'));
      const setSubAccountConfigStatusAuth = JSON.parse(
        sessionStorage.getItem('setSubAccountConfigStatus'),
      );
      this.aadAuth = addSubAccountConfigAuth;
      this.editAuth = editSubAccountConfigAuth;
      this.setStatusAuth = setSubAccountConfigStatusAuth;
    }
  },
  methods: {
    normalizer(node) {
      return {
        id: node.id,
        label: node.name,
        children: node.children,
      };
    },
    search() {
      this.$refs.ledgerSetSearchForm.validate((validate, obj) => {
        if (validate) {
          this.getTableData();
        }
      });
    },
    getTableData(pageData = { currentPage: 1, pageSize: 10 }) {
      this.loading = true;
      this.api
        .post('/subaccount/config/querySubAccountConfigPage.do', {
          ...pageData,
          ...this.form,
        })
        .then(({ code, data, message }) => {
          if (code === 200) {
            data.result?.forEach((item) => {
              item.popVisible = false;
            });
            this.tableData = data.result || [];
            this.total = Number(data.aCount);
          } else {
            this.$message.error(message);
          }
          this.loading = false;
        });
    },
    resetSearchForm() {
      this.$refs.ledgerSetSearchForm.resetFields();
      this.getTableData();
    },
    showAddDetail() {
      if (this.aadAuth) {
        this.addVisible = !this.addVisible;
      } else {
        this.$message.error('您无添加分账权限，请联系企业开通权限');
      }
    },
    showEditDetail(row) {
      if (this.editAuth) {
        this.editVisible = !this.editVisible;
        this.api
          .post('/subaccount/config/getSubAccountConfig.do', { id: row.id })
          .then(({ code, data, message }) => {
            if (code === 200) {
              this.editFormData = data;
            } else {
              this.$message.error(message);
            }
          });
      } else {
        this.$message.error('您无编辑分账权限，请联系企业开通权限');
      }
    },
    handlePopoverClose(row) {
      row.popVisible = false;
    },
    changeStatus(row) {
      if (this.setStatusAuth) {
        this.handlePopoverClose(row);
        this.api
          .post('/subaccount/config/setStatus.do', {
            id: row.id,
            status: !row.status,
          })
          .then(({ code, message }) => {
            if (code === 200) {
              this.$message.success(message);
            } else {
              this.$message.error(message);
            }
            this.getTableData(this.pageObj);
          });
      } else {
        this.$message.error('您无禁用启用分账权限，请联系企业开通权限');
      }
    },
    handleCurrentChange(val) {
      this.pageObj.currentPage = val;
      this.pageObj = { ...this.pageObj };
      this.getTableData(this.pageObj);
    },
    handleSizeChange(size) {
      this.pageObj = { pageSize: size, currentPage: 1 };
      this.getTableData(this.pageObj);
    },
    handleModalClose(type) {
      type === 'add' && (this.addVisible = false);
      type === 'edit' && (this.editVisible = false);
    },
  },
};
</script>
<style scoped lang="scss">
.ledger-settings {
  .form-select,
  .w224 {
    width: 224px;
  }
  .ledger-search-operation-item {
    margin-left: 100px;
  }
  .ledger-set-content {
    .show-add-ledger-button {
      margin-top: 6px;
      margin-bottom: 32px;
      width: 82px;
    }
  }
  .column-set-maxProportion-text {
    text-align: right;
    width: 82px;
  }
  ::v-deep th:nth-child(4) > .cell {
    margin-left: 8px;
  }
  ::v-deep td:nth-child(4) > .cell{
    padding-left: 0;
  }
  .column-set-proportion-text {
    text-align: right;
    width: 74px;
  }
}
.ledger-settings-popconfirm-title-wrap {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  .ledger-info-icon {
    color: #faad14;
    height: 20px;
    line-height: 20px;
  }
}
.ledger-forbidden-text {
  margin-left: 10px;
}
</style>
